import { DateTime } from 'luxon';

/*
 * Natural Sort algorithm for Javascript - Version 0.8.1 - Released under MIT license
 * Author: Jim Palmer (based on chunking idea from Dave Koelle)
 *
 * WARNING: Function has been customized to process monetary values as well as formatted dates
 * WARNING: If upgrading to latest version, customizations should be preserved
 * WARNING: Each customization is wrapped with comments
 */
export const natural = (a, b) => {
  const re = /(^([+-]?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?(?=\D|\s|$))|^0x[\da-fA-F]+$|\d+)/g;
  const sre = /^\s+|\s+$/g;
  const snre = /\s+/g;
  const dre = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[/-]\d{1,4}[/-]\d{1,4}|^\w+, \w+ \d+, \d{4})/;
  const hre = /^0x[0-9a-f]+$/i;
  const ore = /^0/;
  const i = (s) => ((natural?.insensitive && `${s}`.toLowerCase()) || `${s}`).replace(sre, '');
  const x = i(a);
  const y = i(b);
  const xN = x
    .replace(re, '\0$1\0')
    .replace(/\0$/, '')
    .replace(/^\0/, '')
    .split('\0');
  const yN = y
    .replace(re, '\0$1\0')
    .replace(/\0$/, '')
    .replace(/^\0/, '')
    .split('\0');

  /* BEGIN-CUSTOMIZATION: modify how monetary, numerical and date values are processed */
  /*
   * original values:
   *
   * const xD = parseInt(x.match(hre), 16) || (xN.length !== 1 && Date.parse(x));
   * const yD = parseInt(y.match(hre), 16) || (xD && y.match(dre) && Date.parse(y)) || null;
   */
  const cre = /^\$?-?([1-9]{1}[0-9]{0,2}(,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))$|^-?\$?([1-9]{1}\d{0,2}(,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))$|^\(\$?([1-9]{1}\d{0,2}(,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))\)$/gi;
  const nre = /[^0-9-]/gi;
  const df = (o) => {
    const d = DateTime.fromFormat(o, natural?.dateFormat || 'dd/MM/yyyy', {
      locale: natural?.locale || 'en-AU'
    });
    return d.toJSDate() || 0;
  };
  const xD =
    parseInt(x.match(hre), 16) ||
    (x.match(cre) && x.charAt(0) === '$' && parseFloat(x.replace(nre, ''))) ||
    (xN.length !== 1 && x.match(dre) && df(x));
  const yD =
    parseInt(y.match(hre), 16) ||
    (y.match(cre) && y.charAt(0) === '$' && parseFloat(y.replace(nre, ''))) ||
    (xD && y.match(dre) && df(y)) ||
    null;
  /* END-CUSTOMIZATION */

  const normChunk = (s, l) =>
    ((!s.match(ore) || l === 1) && parseFloat(s)) || s.replace(snre, ' ').replace(sre, '') || 0;
  let oFxNcL;
  let oFyNcL;
  if (yD) {
    if (xD < yD) {
      return -1;
    }
    if (xD > yD) {
      return 1;
    }
  }
  for (
    let cLoc = 0, xNl = xN.length, yNl = yN.length, numS = Math.max(xNl, yNl);
    cLoc < numS;
    cLoc += 1
  ) {
    oFxNcL = normChunk(xN[cLoc] || '', xNl);
    oFyNcL = normChunk(yN[cLoc] || '', yNl);
    if (Number.isNaN(oFxNcL) !== Number.isNaN(oFyNcL)) {
      return Number.isNaN(oFxNcL) ? 1 : -1;
    }
    /* eslint-disable no-control-regex */
    if (/[^\x00-\x80]/.test(oFxNcL + oFyNcL) && oFxNcL.localeCompare) {
      const comp = oFxNcL.localeCompare(oFyNcL);
      return comp / Math.abs(comp);
    }
    /* eslint-enable no-control-regex */
    if (oFxNcL < oFyNcL) {
      return -1;
    }
    if (oFxNcL > oFyNcL) {
      return 1;
    }
  }
};

export default {
  natural
};
